function n(n,r,t=(n=>n),o=""){if(!r)return o;const e=n[t(r)];return void 0!==e?e:o}export{n as getEnumValueFromStringKey};
